import { Menu } from '@domain/menu/menu';
import { MenuDto } from '../dto/menu.dto';
import { IconeMapper } from './icone.mapper';

export class MenuMapper {
  static toDTO(menu: Menu): MenuDto {
    return {
      id: menu.id,
      IdFuncionalidade: menu.id,
      ordem: parseInt(menu.order),
      titulo: menu.label,
      icone: IconeMapper.toDTO(menu.icon),
      idMenuPai: menu.parentId ?? 0,
      nivel: menu.level,
      url: menu.url,
      itemMenu: menu.children.map(MenuMapper.toDTO) // Mapeando os filhos recursivamente
    };
  }

  static toDomain(menuDto: MenuDto): Menu {
    return {
      id: menuDto.id,
      parentId: menuDto.nivel ?? null, // Caso o menu não tenha um pai, será null
      label: menuDto.titulo,
      level: menuDto.nivel,
      root: menuDto.nivel === 1, // Caso não tenha pai, é o root
      order: menuDto.ordem.toString(), // Convertendo ordem para string
      expanded: false, // Inicializando o expanded como falso, isso pode ser alterado conforme necessário
      actived: false, // Inicializando o actived como verdadeiro
      url: menuDto.url?.toString() ?? '',
      children: menuDto.itemMenu.map(MenuMapper.toDomain), // Mapeando os filhos recursivamente
      icon: IconeMapper.toDomain(menuDto.icone)
    };
  }
}
